module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "cer",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.cer
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.certificateName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.cer.name),
      callback: function($$v) {
        _vm.$set(_vm.cer, "name", $$v)
      },
      expression: "cer.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.cer.mark),
      callback: function($$v) {
        _vm.$set(_vm.cer, "mark", $$v)
      },
      expression: "cer.mark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadType == 1),
      expression: "uploadType == 1"
    }],
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": ""
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "cclasss": "'w_33'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cerFile'),
      "prop": "curl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.removeFile,
      "before-upload": _vm.cerBefore,
      "on-success": _vm.cerSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('app_plsUlPbCer')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d47dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/cerUpload.vue
// module id = 953
// module chunks = 0